import { cn } from "@/lib/utils";
import type { DailyTimelineLabels } from "./types";

interface DaySummaryProps {
  done: number;
  active: number;
  remaining: number;
  labels: DailyTimelineLabels;
}

export function DaySummary({ done, active, remaining, labels }: DaySummaryProps) {
  return (
    <div
      className="px-3 pb-2 text-center"
      role="status"
      aria-live="polite"
    >
      <div className={cn("inline-flex items-center gap-2 text-xs text-biz-foreground-muted font-mono-num")}>
        {labels.summary({ done, active, remaining })}
      </div>
    </div>
  );
}
